import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MailboxEntryData } from '../models/mailboxes.model';
import { ApplicationState, getSelectedMailbox } from '../../store/reducers';
import { Store } from '@ngrx/store';

@Injectable()
export class PasswordRecoveryManagementValidator {
  selectedValues: Array<string>;

  constructor(private store: Store<ApplicationState>) {
    store
      .select(getSelectedMailbox)
      .subscribe((selectedMailbox: MailboxEntryData) => {
        this.selectedValues = [];
        if (selectedMailbox) {
          this.selectedValues.push(selectedMailbox.mbxId);

          if (Array.isArray(selectedMailbox.aliases)) {
            selectedMailbox.aliases.forEach((alias) => {
              this.selectedValues.push(alias.aliasId);
            });
          }
        }
      });
  }

  checkForbiddenRecoveryEmailValues() {
    return (control: AbstractControl): { [key: string]: any } => {
      const forbidden = this.selectedValues.includes(control.value);
      return forbidden ? { forbiddenValues: { value: control.value } } : null;
    };
  }
}
